import { render, staticRenderFns } from "./to-cart-btn.vue?vue&type=template&id=90dd5a9a&"
import script from "./to-cart-btn.vue?vue&type=script&lang=js&"
export * from "./to-cart-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports